import { ICON__chevron_down } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { ENUM_UTILS__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { useTranslation } from 'react-i18next';

export function G_DROPDOWN__image_select_category() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();
  const { t, i18n } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { g_image_edit__replace__category, g_image_edit__field } = use_slice_ui(['g_image_edit__replace__category', 'g_image_edit__field']);
  /*
   * STATE
   */

  const trigger_id = 'G_DROPDOWN__image_select_category';

  /*
   * EVENTS
   */
  async function on_item_selected(value: string) {
    dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__replace__category', value, valid_values: [] }));
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_items() {
    return Object.values(ENUM_UTILS__image_asset_category.values_without_any()).map(value => {
      return (
        <UI_PRIMITIVE__dropdown_menu_item
          key={value}
          class_name_hovered_selected={`bg-component-item`}
          values_selected={[g_image_edit__replace__category]}
          label={value}
          {...{ on_item_selected, value }}
          className={`settings-dropdown-item  text-page-foreground`}
        />
      );
    });
  }

  /*
   * HTML
   */
  if (g_image_edit__field.is_stub()) return <PLACEHOLDER_bar_line />;

  return (
    <div className="flex flex-col gap-1 flex-center w-full">
      <div className="text-sm w-full text-left text-bar-foreground">Category</div>
      <UI_PRIMITIVE__dropdown_menu>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          {/* we cant choose category so it is disabled */}
          <UI_PRIMITIVE__button disabled id={trigger_id} className="text-component-foreground w-full px-2" variant="outline-on-component" size={'full-8'}>
            <div className="flex-1 h-full truncate flex items-center justify-start">{g_image_edit__replace__category}</div>
            <ICON__chevron_down className="!size-3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>
        <UI_PRIMITIVE__dropdown_menu_content trigger_id={trigger_id}>{render_items()}</UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </div>
  );
}
